import { Text } from '@mantine/core';
import { IconDragDrop } from '@tabler/icons';
import { FC } from 'react';

const DropArea: FC<{ isOver?: boolean }> = ({ isOver = false }) => (
  <Text
    weight="bolder"
    mt="md"
    color="blue"
    p="md"
    sx={{
      border: '3px dashed #1D5191',
      backgroundColor: isOver ? '#C9DDF8' : '#DFEBFB',
      transition: 'background-color 120ms ease',
    }}
  >
    <IconDragDrop size={20} style={{ marginTop: -4, marginRight: 10 }} /> Hier einfügen
  </Text>
);

export default DropArea;
